import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { isArrayLike } from 'mobx';

interface ProductCategoryEditorViewProps {
	productCategoryRequest: DropdownRequest<ProductCategorySummary>;
	value: number|number[] | null;
	mode: ControlMode;
	onChanged?: (number: ProductCategorySummary ) => void;
	multiOnChange?: (values: ProductCategorySummary[]) => void;
	label?: string;
	afterLoad?: (value: any) => void;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	productType?: number | number[];
	baseCategoriesEnabled?: boolean;
	multi?: boolean
}

export class ProductCategoryEditorView extends React.Component<ProductCategoryEditorViewProps, {}> {
	private disableOption = (item: ProductCategorySummary): boolean => item.hasChildren;

	render(): React.ReactNode {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Product category';
		}

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				multi={this.props.multi}
				disabled={this.props.mode == 'display'}
				model={this.props.value}
				onChanged={this.props.multi != null && this.props.multi==true ? this.props.multiOnChange : this.props.onChanged}
				request={this.props.productCategoryRequest}
				keyField="id"
				textField="displayName"
				afterLoad={this.props.afterLoad}
				required={this.props.required}
				cascadeField={!isArrayLike(this.props.productType) ? "productType" : null}
				cascadeValue={!isArrayLike(this.props.productType) ? (this.props.productType as number) : null}
				disableOption={this.props.baseCategoriesEnabled ? undefined: this.disableOption}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/parts/product-category-editor.view.tsx